// 验证

/* 邮箱 */
export function validateEmail(str) {
  // const reg = /[\w!#$%&'*+=?^_`{|}~-]+(?:\.[\w!#$%&'*+=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
  const reg = /^[a-zA-Z\d][-\.\w]*@(?:[-\w]+\.)+(?:[a-zA-Z])+$/
  return reg.test(str)
}

/* 手机 */
export function validatePhone(str) {
  const reg = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[0-9]{1}))+\d{8})$/
  return reg.test(str)
}